module.exports = __webpack_public_path__ + "media/src/images/icons/eye/opened-white-5d3739cc86d7a7929d842b13f574280f.svg";